import { createStyles, getStylesRef, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    button: {
        width: "100%",
        padding: ".75rem 2rem",
        height: rem(56),
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
    },
    container: {
        padding: "1.5rem 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflow: "auto",
        maxHeight: rem(470),
        margin: 0,

        "&:hover::-webkit-scrollbar-thumb": {
            background: "rgba(0,0,0,.3)",
            borderRadius: "1rem",
            border: "0.125rem solid rgba(0,0,0,.0)",
            backgroundClip: "padding-box",
            padding: "0.125rem",
        },

        "&::-webkit-scrollbar-thumb": {
            background: "rgba(0,0,0,.0)",
        },

        "&::-webkit-scrollbar-track": {
            background: "transparent",
        },

        "&::-webkit-scrollbar": {
            width: "0.5rem",
            background: "transparent",
        },
    },
    itemContainer: {
        position: "relative",
        width: "100%",
        height: rem(56),
        display: "flex",
        alignItems: "center",

        "&:hover": {
            background: theme.colors.violet[0],
            [`& .${getStylesRef("actionIcon")}`]: {
                color: theme.colors.gray[7],
            },
        },

        transition: "background-color .3s ease-in-out",
    },
    iconContainer: {
        ref: getStylesRef("iconContainer"),
        fontSize: "0.875rem",
        color: theme.colors.gray[7],
        maxWidth: "2rem",
        maxHeight: "2rem",
        minWidth: "2rem",
        minHeight: "2rem",
        marginRight: theme.spacing.md,
        borderRadius: "50%",
        backgroundColor: theme.colors.gray[1],
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    searchText: {
        color: theme.colors.gray[7],
        fontSize: rem(14),
        marginRight: "2.25rem",
        display: "flex",
        justifyContent: "flex-start",
        maxWidth: "34rem",
        width: "100%",
    },
    text: {
        maxWidth: rem(455),
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    dataTypeText: {
        width: rem(140),
        fontSize: rem(12),
        fontWeight: 500,
        textTransform: "uppercase",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        ".mantine-Text-root": {
            color: theme.colors.gray[6],
            fontSize: rem(12),
            fontWeight: 500,
            textTransform: "uppercase",
        },
    },
    actionsContainer: {
        position: "absolute",
        right: "2rem",
        display: "flex",
        gap: "0.75rem",
        justifyContent: "center",
        alignItems: "center",
    },
    actionIcon: {
        ref: getStylesRef("actionIcon"),
        padding: 0,
        margin: 0,
        minWidth: 0,
        minHeight: 0,
        width: rem(24),
        height: rem(24),
        color: "transparent",
        "&:hover": {
            "&&": {
                color: theme.colors.violet[7],
            },
        },
    },
    timesIcon: {
        fontSize: "1rem",
    },
    starIcon: {
        fontSize: "0.75rem",
    },
    emptySearchContainer: {
        padding: "4rem 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    emptySearchIcon: {
        width: "4rem",
        height: "4rem",
        marginBottom: "2rem",
        borderRadius: "50%",
        backgroundColor: theme.colors.violet[1],
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "1.5rem",
    },
    emptySearchTextContainer: {
        height: "100%",
        maxWidth: rem(450),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    emptySearchTitle: {
        "&": {
            color: theme.colors.gray[9],
            fontSize: rem(18),
            fontWeight: 500,
            marginBottom: ".5rem",
        },
    },
    emptySearchText: {
        color: theme.colors.gray[7],
        fontSize: rem(14),
        textAlign: "center",
    },
    noMoreResultsText: {
        color: theme.colors.gray[7],
        fontSize: rem(14),
        display: "flex",
        padding: "2rem 2rem 1rem 2rem",
        flexDirection: "column",
        alignItems: "center",
        gap: "0.5rem",
    },
}))
